import moduleActions from "./actions";
import moduleGetters from "./getters";
import moduleMutations from "./mutations";

const initialState = () => ({
  events: {},
  limit: 10
});

export const events = {
  namespaced: true,
  actions: moduleActions,
  getters: moduleGetters,
  mutations: moduleMutations,
  state: initialState
};
